import React from 'react';

/**
 * Reusable Confirmation Modal Component
 * Used for confirmations with optional input
 */
export const ConfirmationModal = ({
  title,
  message,
  inputLabel,
  inputValue,
  onInputChange,
  onConfirm,
  onCancel,
  confirmText = 'Onayla',
  cancelText = 'İptal',
  confirmStyle = 'primary' // 'primary', 'danger', 'warning'
}) => {
  const getConfirmButtonStyle = () => {
    const styles = {
      primary: 'bg-blue-600 hover:bg-blue-700 text-white',
      danger: 'bg-red-600 hover:bg-red-700 text-white',
      warning: 'bg-yellow-600 hover:bg-yellow-700 text-white'
    };
    return styles[confirmStyle] || styles.primary;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">{title}</h3>
        
        <p className="text-gray-600 mb-4">{message}</p>
        
        {inputLabel && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {inputLabel}
            </label>
            <input
              type="text"
              value={inputValue || ''}
              onChange={(e) => onInputChange?.(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Açıklama girin..."
            />
          </div>
        )}
        
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-md transition-colors ${getConfirmButtonStyle()}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
